import DotCoffeeLogo from './dot-coffee.svg';
import LittlesOysterBarLogo from './littles-oyster-bar.svg';
import PappadeauxLogo from './pappadeaux.svg';
import PappasBbqLogo from './pappas-bbq.svg';
import PappasBrosLogo from './pappas-bros.svg';
import PappasBurgerLogo from './pappas-burger.svg';
import PappasDeltaBluesLogo from './pappas-delta-blues.svg';
import PappasSeafoodLogo from './pappas-seafood.svg';
import PappasitosLogo from './pappasitos.svg';
import YiayiasLogo from './yiayias.svg';

export default {
    DotCoffeeLogo,
    LittlesOysterBarLogo,
    PappadeauxLogo,
    PappasBbqLogo,
    PappasBrosLogo,
    PappasBurgerLogo,
    PappasDeltaBluesLogo,
    PappasSeafoodLogo,
    PappasitosLogo,
    YiayiasLogo,
}
